import Alert from '@pelckmans/elementis/components/alert';
import AlertGroup from '@pelckmans/elementis/components/alert-group';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormValues } from '../EditGroupModal';

export default function EditGroupAlerts() {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors, isSubmitted, isValid },
  } = useFormContext<FormValues>();

  const status = useWatch({ control, name: 'status' });
  const isPublished = status === 'published';

  return isSubmitted && !isValid ? (
    <AlertGroup aria-label={undefined} role={undefined} className="availability-alerts">
      {(errors.name || errors.endDate) && <Alert prominence="danger">{t('ALERTS.INVALID.MESSAGE')}</Alert>}
      {isPublished && errors.totalAccepted && (
        <Alert key="no-accepted" prominence="danger">
          {errors.totalAccepted.message!}
        </Alert>
      )}
      {isPublished && errors.linkedModulesCount && (
        <Alert key="no-modules" prominence="danger">
          {errors.linkedModulesCount.message!}
        </Alert>
      )}
    </AlertGroup>
  ) : null;
}
